<glxy-page [pagePadding]="true">
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'EMAIL_LIBRARY.TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-actions *ngIf="showPageActions">
      <ng-container *ngIf="!openAsReadOnly">
        <a [routerLink]="['/marketing/email-library/editor/new']">
          <button mat-flat-button color="primary" (click)="registerPosthog()">
            {{ 'EMAIL_LIBRARY.CREATE_EMAIL_BUTTON_TEXT' | translate }}
          </button>
        </a>
      </ng-container>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <email-library-list
    [openAsReadOnly]="openAsReadOnly"
    [ownerType]="ownerType"
    [ownerId]="ownerId"
    [userId]="userId"
    (readOnlyEmailClicked)="handleReadOnlyEmailClicked($event)"
  ></email-library-list>
</glxy-page>
